module.exports = __webpack_public_path__ + "static/media/inf_37og38.9438b0c6.mp3";